"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _Application = _interopRequireDefault(require("react-rainbow-components/components/Application"));

var _RenderIf = _interopRequireDefault(require("react-rainbow-components/components/RenderIf"));

var _firebaseHooks = require("@rainbow-modules/firebase-hooks");

var _ReduxContainer = _interopRequireDefault(require("../ReduxContainer"));

var _I18nContainer = _interopRequireDefault(require("../I18nContainer"));

var _AppSpinner = _interopRequireDefault(require("../AppSpinner"));

var _AppMessage = _interopRequireDefault(require("../AppMessage"));

var _ConfirmModal = _interopRequireDefault(require("../ConfirmModal"));

var _actions = require("../../actions");

var _getBrowserLocale = _interopRequireDefault(require("../../helpers/getBrowserLocale"));

var RainbowFirebaseApp = function RainbowFirebaseApp(props) {
  var app = props.app,
      theme = props.theme,
      locale = props.locale,
      translations = props.translations,
      children = props.children,
      reducers = props.reducers,
      initialize = props.initialize,
      spinner = props.spinner;
  var firebaseContext = (0, _react.useMemo)(function () {
    return {
      app: app
    };
  }, [app]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isLoading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isMessageVisible = _useState4[0],
      setIsMessageVisible = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      isConfirmModalVisible = _useState6[0],
      setIsConfirmModalVisible = _useState6[1];

  var _useState7 = (0, _react.useState)({}),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      messageParams = _useState8[0],
      setMessageParams = _useState8[1];

  var _useState9 = (0, _react.useState)({}),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      confirmModalParams = _useState10[0],
      setConfirmModalParams = _useState10[1];

  var _useState11 = (0, _react.useState)(true),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      isInitializing = _useState12[0],
      setIsInitializing = _useState12[1];

  var applicationLocale = locale || (0, _getBrowserLocale["default"])();
  (0, _react.useEffect)(function () {
    (0, _actions.updateAppActions)({
      setLoading: setLoading,
      setIsMessageVisible: setIsMessageVisible,
      setMessageParams: setMessageParams,
      setIsConfirmModalVisible: setIsConfirmModalVisible,
      setConfirmModalParams: setConfirmModalParams
    });
  }, []);
  (0, _react.useEffect)(function () {
    function initializeApp() {
      return _initializeApp.apply(this, arguments);
    }

    function _initializeApp() {
      _initializeApp = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!initialize) {
                  _context.next = 5;
                  break;
                }

                setLoading(true);
                _context.next = 4;
                return initialize();

              case 4:
                setLoading(false);

              case 5:
                setIsInitializing(false);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _initializeApp.apply(this, arguments);
    }

    initializeApp(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_ReduxContainer["default"], {
    reducers: reducers
  }, /*#__PURE__*/_react["default"].createElement(_firebaseHooks.FirebaseProvider, {
    value: firebaseContext
  }, /*#__PURE__*/_react["default"].createElement(_I18nContainer["default"], {
    locale: applicationLocale,
    messages: translations[applicationLocale]
  }, /*#__PURE__*/_react["default"].createElement(_Application["default"], {
    theme: theme,
    locale: applicationLocale
  }, /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: !isInitializing
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, null, children)), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: isLoading
  }, /*#__PURE__*/_react["default"].createElement(_AppSpinner["default"], {
    spinner: spinner
  })), /*#__PURE__*/_react["default"].createElement(_AppMessage["default"], (0, _extends2["default"])({
    isVisible: isMessageVisible,
    onHideMessage: function onHideMessage() {
      return setIsMessageVisible(false);
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, messageParams)), /*#__PURE__*/_react["default"].createElement(_ConfirmModal["default"], (0, _extends2["default"])({
    isOpen: isConfirmModalVisible // eslint-disable-next-line react/jsx-props-no-spreading

  }, confirmModalParams))))));
};

RainbowFirebaseApp.propTypes = {
  /** The firebase app instance already initialized. */
  app: _propTypes["default"].object.isRequired,

  /** The react-rainbow-components theme object. By default will use react-rainbow-components
  * default theme */
  theme: _propTypes["default"].object,

  /** The application language tag or locale identifier */
  locale: _propTypes["default"].string,

  /** The translation object used by react-intl to resolve proper translations
  * of FormmatedMessage components */
  translations: _propTypes["default"].object,

  /** Object with your application Redux reducers. */
  reducers: _propTypes["default"].object,

  /** An async function to initialize the app. AppSpiner will be visible while this function is running. */
  initialize: _propTypes["default"].func,

  /** The spinner to show when the app is loading. */
  spinner: _propTypes["default"].node,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].object])
};
RainbowFirebaseApp.defaultProps = {
  theme: undefined,
  locale: undefined,
  translations: {},
  children: null,
  spinner: null,
  reducers: {},
  initialize: undefined
};
var _default = RainbowFirebaseApp;
exports["default"] = _default;